import { Modal } from 'antd';
import type { ModalProps } from 'antd';

export interface DModalProps extends ModalProps {}

export const DarwinModal = (props: DModalProps) => {
  return <Modal {...props} />;
};
